import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import { logout } from '../../Services/Authentication';
import { useNavigate } from 'react-router-dom';
import Notifications from '../Notification/Notifications';
import { GetAccount } from '../../Services/Account';
import { AppDispatch, RootState } from '../store/store';
import { useSelector, useDispatch } from "react-redux";
import { fetchHeaderData } from '../store/headerSlice';
import Upgrade from './upgrade';
import { useTranslation } from 'react-i18next';


const Header: React.FunctionComponent<{ background: string }> = (props) => {

    const navigate = useNavigate();
    const [profileValue, setProfileValue] = useState<any>(JSON.parse(localStorage.getItem('profile') || '{}'));
    const dispatch = useDispatch<AppDispatch>();
    const { generatephotos, enhancephotos, listings } = useSelector((state: RootState) => state.header);
    const [langue, setLangue] = useState<any>(localStorage.getItem('language') ? localStorage.getItem('language') : "en");
    const [languages, setLanguges] = useState<any>([{
        "lang": "English", "value": "en", "icon": <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1240_2140)">
                <path d="M21 0.5H0V14.5002H21V0.5Z" fill="white" />
                <path d="M11.8125 0.5H9.1875V6.18747H0V8.81247H9.1875V14.4999H11.8125V8.81247H21V6.18747H11.8125V0.5Z" fill="#D80027" />
                <path d="M16.1523 9.93457L21.001 12.6283V9.93457H16.1523Z" fill="#0052B4" />
                <path d="M12.7832 9.93457L21.0006 14.4998V13.2088L15.1069 9.93457H12.7832Z" fill="#0052B4" />
                <path d="M18.8118 14.4999L12.7832 11.1504V14.4999H18.8118Z" fill="#0052B4" />
                <path d="M12.7832 9.93457L21.0006 14.4998V13.2088L15.1069 9.93457H12.7832Z" fill="white" />
                <path d="M12.7832 9.93457L21.0006 14.4998V13.2088L15.1069 9.93457H12.7832Z" fill="#D80027" />
                <path d="M3.70539 9.93457L0 11.9931V9.93457H3.70539Z" fill="#0052B4" />
                <path d="M8.21777 10.5151V14.4998H1.0459L8.21777 10.5151Z" fill="#0052B4" />
                <path d="M5.89366 9.93457L0 13.2088V14.4998L8.2174 9.93457H5.89366Z" fill="#D80027" />
                <path d="M4.84866 5.06532L0 2.37158V5.06532H4.84866Z" fill="#0052B4" />
                <path d="M8.2174 5.0652L0 0.5V1.79093L5.89366 5.0652H8.2174Z" fill="#0052B4" />
                <path d="M2.18848 0.5L8.21704 3.8495V0.5H2.18848Z" fill="#0052B4" />
                <path d="M8.2174 5.0652L0 0.5V1.79093L5.89366 5.0652H8.2174Z" fill="white" />
                <path d="M8.2174 5.0652L0 0.5V1.79093L5.89366 5.0652H8.2174Z" fill="#D80027" />
                <path d="M17.2949 5.06541L21.0003 3.00684V5.06541H17.2949Z" fill="#0052B4" />
                <path d="M12.7832 4.48471V0.5H19.9551L12.7832 4.48471Z" fill="#0052B4" />
                <path d="M15.1069 5.0652L21.0006 1.79093V0.5L12.7832 5.0652H15.1069Z" fill="#D80027" />
            </g>
            <defs>
                <clipPath id="clip0_1240_2140">
                    <rect y="0.5" width="21" height="14" rx="2" fill="white" />
                </clipPath>
            </defs>
        </svg>
    },
    {
        "lang": "French", "value": "fr", "icon": <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <image
                href="/assets/images/icons/fr.svg"
                x="0"
                y="0"
                width="21"
                height="15"
            />
        </svg>
    },
    {
        "lang": "Spanish ", "value": "es", "icon": <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <image
                href="/assets/images/icons/es.svg"
                x="0"
                y="0"
                width="21"
                height="15"
            />
        </svg>
    },
        // {
        //     "lang": "Arabic ", "value": "ar", "icon": <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        //         <image
        //             href="/assets/images/icons/sa.svg"
        //             x="0"
        //             y="0"
        //             width="21"
        //             height="15"
        //         />
        //     </svg>
        // }
    ])
    const { t, i18n } = useTranslation();

    useEffect(() => {
        dispatch(fetchHeaderData());
    }, [dispatch]);

    useEffect(() => {
        GetAccount().then((data: any) => {
            setProfileValue(data);
            localStorage.setItem('profile', JSON.stringify({
                "profile_picture": data.profile_picture,
                "name": data.name,
                "family_name": data.family_name
            }));
        }).catch(() => {
            console.log("error")
            logout();
            navigate("/login");
        })

    }, [])


    const formatNumber = (num: number) => {
        if (num >= 1000000) {
            return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M'; // 1.2M
        } else if (num >= 1000) {
            return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'k'; // 79k
        }
        return num.toString();
    };

    const changeLanguage = (lng: any) => {
        i18n.changeLanguage(lng);
        localStorage.setItem('language', lng);
        setLangue(lng)
        document.body.classList.toggle('rtl', lng === 'ar');
        document.body.classList.toggle('ltr', lng !== 'ar');
    };

    const getSidebar = (event: any) => {
        event.preventDefault();
        $("html").toggleClass("layout-menu-expanded");
    }



    return (
        <nav className={`layout-navbar  ${props.background}`} id="layout-navbar">

            <div className="navbar-nav-right" id="navbar-collapse">
                <div className="row padd-24-16-16 ">
                    <a href="/properties" >
                        <img src="/assets/images/icons/coralytics.webp" className='display-none-web height-38' />
                    </a>
                </div>
                {props.background !== "back-FFFFFF" && <a href="/properties" className="app-brand-link display-none-mb">
                    <img src="/assets/images/icons/coralytics.webp" className="logo-cora-head" />
                </a>}
                <div className="layout-menu-toggle">
                    <button className="border-trans back-trans button-sidebar" onClick={getSidebar}>
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 16H28" stroke="#282828" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 8H28" stroke="#282828" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M4 24H28" stroke="#282828" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>

                    </button>
                </div>
                <div className="balance-card  display-balance-mb back-indigo border-10">
                    <div className="balance-content">
                        <div className="balance-details">
                            <h3 className='mb-1 mt-1'>{t('navbar.balanceCard.balance')}</h3>
                            <div className="detail">
                                <span className="title-B ">{t('navbar.balanceCard.enhance')}</span>
                                <span className="value ">{enhancephotos && formatNumber(enhancephotos)}</span>
                                <span className="subtitle">{t('navbar.balanceCard.photos')}</span>
                            </div>
                            <div className="detail">
                                <span className="title-B ">{t('navbar.balanceCard.generate')}</span>
                                <span className="value "> {generatephotos && formatNumber(generatephotos)}</span>
                                <span className="subtitle">{t('navbar.balanceCard.photos')}</span>
                            </div>
                            <div className="detail">
                                <span className="title-B ">{t('navbar.balanceCard.listings')}</span>
                                <span className="value "> {listings && formatNumber(listings)}</span>
                                <span className="subtitle">{t('navbar.balanceCard.listing')}</span>
                            </div>
                        </div>
                    </div>
                    <Upgrade />
                </div>
                <ul className="navbar-nav flex-row align-items-center media-nav ms-auto-left">
                    <li className="nav-item lh-1  lang-cora dropdown"  >
                        <div className="dropdown">
                            <button
                                className="btn dropdown-toggle d-flex gap-8 para-14 color-black bold-400 back-trans border-trans"
                                type="button"
                                id="dropdownMenuButton"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                            >
                                {languages.find((item: any) => item.value === langue)?.icon}
                                {languages.find((item: any) => item.value === langue)?.lang}
                                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clipPath="url(#clip0_519_427)">
                                        <path d="M3.5 5.75L7 9.25L10.5 5.75" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_519_427">
                                            <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </button>
                            <ul className="dropdown-menu text-center" aria-labelledby="dropdownMenuButton">
                                {languages.map((lang: any, index: number) => {
                                    return <li key={index}><a className="dropdown-item" onClick={() => changeLanguage(lang.value)}><span className='marg-right-10'>{lang.icon}</span>{lang.lang}</a></li>
                                })}
                            </ul>
                        </div>

                    </li>
                    <li className="nav-item lh-1 nav-notif">
                        <Notifications />
                    </li>
                    <li className="nav-item">
                        <div className='line-header'></div>
                    </li>
                    <li className="nav-item lh-1  dropdown dropdown-authentication">
                        <button className="nav-link border-trans back-trans" onClick={() => navigate('/profile')}>
                            {profileValue ? <div className="media">
                                <div className="media-img-wrap">
                                    <img src={profileValue.profile_picture == "" ? "/assets/images/icons/logo-user.png" : profileValue.profile_picture} alt="user" className="avatar-img" />
                                </div>
                                <div className="media-body">
                                    <span className='d-flex'>{profileValue.family_name == "" ? "Admin Admin" : profileValue.family_name + " " + profileValue.name}</span>
                                </div>
                            </div> : <div className="media">
                                <div className="media-img-wrap">
                                    <div className="avatar">
                                        <img src={"/assets/images/icons/logo-user.png"} alt="user" className="avatar-img" />
                                    </div>
                                </div>
                                <div className="media-body">
                                    <span>{"Admin Admin"}</span>
                                </div>
                            </div>}
                        </button>
                        
                    </li>
                </ul>
            </div>
        </nav >
    )
}

export default Header